import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from './../../../common/constants/master-constants';

import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { CppReturnAddProductSliderModelService } from '../cpp-return-add-product/cpp-return-product-slider-model.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-cpp-return-add-product',
  templateUrl: './cpp-return-add-product.component.html',
  styleUrls: ['./cpp-return-add-product.component.scss']
})

export class CppReturnAddProductComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  productList: any;
  parentProductList: any;
  manualProductList: any;
  tabProductList: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  productAllDataSource: any;
  parentAccountDataSource: any;
  gridManualProductDataSource: any;
  isProductNotAdded = true;
  selectedProductList = new Array();
  itemList = new Array();
  filterTypeList = new Array();
  uomMasterList: any;
  displayedColumns: string[] = ['Product Name', 'detail', 'Eligible Units', 'Pack Size', 'Product Line'];
  manualDisplayedColumns: string[] = ['Product Name', 'detail', 'UOM', 'Pack Size', 'Product Line'];
  gridManualProductList: any = [];
  tabManualProductList: any = [];
  uomNumber: any;
  manualProductItem: any;
  manualProductItemDesc: any;
  isShipToNonReturnable = false;
  isParentNonReturnable = false;
  allManualDropdownList: any = [];
  allLotMasterList: any = [];
  private selectedTabIndex = 0;
  isReturnTypeForInnoculant: boolean = false;

  constructor(
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private cppReturnAddProductSliderModelService: CppReturnAddProductSliderModelService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private cppReturnsService: CppReturnsService,
    public excelService: ExcelService) {
  }

  // ngOnInit
  ngOnInit() {

    this.filterTypeList = [
      { label: 'Product Name', column: 'productName' },
      { label: 'Package Size', column: 'packageSize' },
      { label: 'Vendor Name', column: 'vendorName' },
      { label: 'Product Line', column: 'productLine' },
      { label: 'Item Number', column: 'itemNumber' },
      { label: 'Active Ingredient', column: 'activeIngredients' },
      { label: 'GTIN', column: 'gtin' }
    ];

    this.isReturnTypeForInnoculant = this.cppReturnsService.isReturnTypeForInnoculant

    this.getInvoicedProduct();
  }

  showShipToNonReturnableProducts(isChecked) {
    this.isShipToNonReturnable = isChecked;

    if (isChecked) {
      this.productAllDataSource = new MatTableDataSource(this.productList);
    }
    else {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      this.productAllDataSource = new MatTableDataSource(filteredList);
    }
  }
  // search in master search area
  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1;
  }
  // search in master search area
  public filterUOMFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.id.toLocaleLowerCase().indexOf(term) > -1;
  }
  showParentNonReturnableProducts(isChecked) {
    this.isParentNonReturnable = isChecked;
    if (isChecked) {
      this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);
    }
    else {
      const filteredList = this.parentProductList.filter(x => x.displayMessage == null);
      this.parentAccountDataSource = new MatTableDataSource(filteredList);
    }
  }

  // Get Lot# and products list
  getProductMaster(filters) {
    this.subscription.push(this.cppReturnsService.getProductMaster(filters).subscribe((result: any) => {
      this.manualProductList = result;
      this.uomMasterList = null;
      this.uomNumber = null;
    }));
  }

  getUOMByItemNumber(event) {
    this.loaderService.setLoaderStatus(true);
    if (event) {
      const filter = {
        itemId: event.itemId,
        itemNo: event.itemNumber
      };

      this.subscription.push(this.cppReturnsService.getProductUOM(filter).subscribe((result: any) => {
        this.uomMasterList = result;
        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    } else {
      this.resetItems();
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  productSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1
      || item.itemNumber.toLocaleLowerCase().indexOf(term) > -1
      || item.itemVendorName.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Reset the list for lotnumber and products dropdown
  resetItems() {
    this.uomMasterList = null;
    this.uomNumber = null;
    this.manualProductItem = null;
    this.manualProductItemDesc = null;
  }

  createProduct() {
    this.loaderService.setLoaderStatus(true);

    if (!this.gridManualProductList.find(x => x.itemId === this.manualProductItem)) {
      const item = this.manualProductList.find(items => items.itemId === this.manualProductItem);
      const uomData = this.uomMasterList.find(x => x.seq == this.uomNumber);

      item.uom = uomData.uom;
      item.packageSize = uomData.packageSize;

      this.gridManualProductList.push(item);
      this.selectedProductList.push(item);
      this.tabManualProductList = JSON.parse(JSON.stringify(this.gridManualProductList));
      this.gridManualProductDataSource = new MatTableDataSource(this.gridManualProductList);

      this.enableDisableAddProductBtn();
      this.resetItems();
    }
    this.loaderService.setLoaderStatus(false);
  }

  deleteProduct(product) {
    if (product) {
      let index = this.selectedProductList.findIndex(function (element) {
        return element.itemId === product.itemId && element.lotNumber === product.lotNumber;
      });
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }

      index = this.tabManualProductList.findIndex(function (element) {
        return element.itemId === product.itemId && element.lotNumber === product.lotNumber;
      });
      if (index !== -1) {
        this.tabManualProductList.splice(index, 1);
      }

      index = this.gridManualProductList.findIndex(function (element) {
        return element.itemId === product.itemId && element.lotNumber === product.lotNumber;
      });
      if (index !== -1) {
        this.gridManualProductList.splice(index, 1);
      }
      this.gridManualProductDataSource = new MatTableDataSource(this.gridManualProductList);

      this.enableDisableAddProductBtn();
    }
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isSelected = !item.isSelected;
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    const data = [];
    if (this.selectedProductList.length > 0) {// Addition use case implemented asked in bug 74741
      this.selectedProductList.forEach(x => {
        const duplicateData = data.find(y => y.itemNumber == x.itemNumber && y.lotNumber == x.lotNumber);
        if (duplicateData) {
          if (!duplicateData.isParent) {
            if (x.isParent) {
              let index = data.indexOf(duplicateData);
              if (index !== -1) {
                data.splice(index, 1);
              }
              data.push(x);
            }
            else if (!x.isParent && !x.isManualLine) {
              let index = data.indexOf(duplicateData);
              if (index !== -1) {
                data.splice(index, 1);
              }
              data.push(x);
            }
          }
        } else {
          data.push(x);
        }
      });

      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: data.length });
    }
    this.cppReturnAddProductSliderModelService.setData<CppReturnAddProductSliderModelService[]>(data);
    this.cppReturnAddProductSliderModelService.cppReturnClose();
  }

  getInvoicedProduct() {
    var inoculantCode = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE)}"`);
    var inoculantCode2 = JSON.parse(`"${this.localStorageService.get(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2)}"`);
    let filters = {
      accountNumber: this.cppReturnsService.getSelectedAccountNo(),
    };

    if (this.isReturnTypeForInnoculant) {
      filters["productLine"] = [String(inoculantCode), String(inoculantCode2)];
    }

    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.cppReturnsService.getInvoicedProductItems(filters).subscribe((result: any) => {
      if (result) {
        this.tabProductList = result;
        this.loaderService.setLoaderStatus(false);

        this.productList = this.tabProductList.filter(x => x.isParent == false);
        this.productAllDataSource = new MatTableDataSource(this.productList);

        this.parentProductList = this.tabProductList.filter(x => x.isParent == true);
        this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);
        this.showShipToNonReturnableProducts(false);
        this.showParentNonReturnableProducts(false);
        this.setAccInvProdTableHeight();
        this.setcompInvProdTableHeight();
        this.setManualProdTableHeight();
      }
    }));
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      this.isProductNotAdded = false;
    }
    else {
      this.isProductNotAdded = true;
    }
  }

  // Get all product based on filter
  getAllProducts(filters) {
    this.loaderService.setLoaderStatus(true);

    setTimeout(() => {
      const itemNo = filters.itemNo ? filters.itemNo.split(',').map(item => item.trim()) : [];
      const productName = filters.productName ? filters.productName.split(',').map(item => item.trim().toLowerCase()) : [];
      const packageSize = filters.packageSize ? filters.packageSize.split(',').map(item => item.trim().toLowerCase()) : [];
      const vendorName = filters.vendorName ? filters.vendorName.split(',').map(item => item.trim().toLowerCase()) : [];
      const productLine = filters.productLine ? filters.productLine.split(',').map(item => item.trim().toLowerCase()) : [];
      const activeIngredient = filters.activeIngredient ? filters.activeIngredient.split(',').map(item => item.trim().toLowerCase()) : [];
      const gtin = filters.gtin ? filters.gtin.split(',').map(item => item.trim().toLowerCase()) : [];

      if (
        itemNo.length == 0 && packageSize.length == 0 && productName.length == 0 &&
        vendorName.length == 0 && productLine.length == 0 && activeIngredient.length == 0 && gtin.length == 0
      ) {
        this.productList = this.tabProductList.filter(x => x.isParent == false);
        this.parentProductList = this.tabProductList.filter(x => x.isParent == true);
        this.gridManualProductList = this.tabManualProductList;
      } else {
        this.productList = this.tabProductList.filter(x => x.isParent == false &&
          (itemNo.length == 0 || itemNo.includes(x.itemNumber)) &&
          (productName.length == 0 ||
            (productName.filter(x1 => x.itemDescription.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0)) &&
          (packageSize.length == 0 ||
            (packageSize.filter(x1 => x.packageSize.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0)) &&
          (vendorName.length == 0 ||
            (vendorName.filter(x1 => x.itemVendorName.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0)) &&
          (productLine.length == 0 ||
            (productLine.filter(x1 => x1.trim().toLowerCase().indexOf(x.productLine.trim().toLowerCase()) > -1).length > 0)) &&
          (activeIngredient.length == 0 ||
            (activeIngredient.filter(x1 => x.activeIngredients.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0)) &&
          (gtin.length == 0 || (gtin.filter(x1 => x.gtin.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0))
        );

        this.parentProductList = this.tabProductList.filter(x => x.isParent == true &&
          (itemNo.length == 0 || itemNo.includes(x.itemNumber)) &&
          (productName.length == 0 ||
            (productName.filter(x1 => x.itemDescription.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0))
          && (packageSize.length == 0 ||
            (packageSize.filter(x1 => x.packageSize.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0))
          && (vendorName.length == 0 ||
            (vendorName.filter(x1 => x.itemVendorName.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0)) &&
          (productLine.length == 0 ||
            (productLine.filter(x1 => x1.trim().toLowerCase().indexOf(x.productLine.trim().toLowerCase()) > -1).length > 0)) &&
          (activeIngredient.length == 0 ||
            (activeIngredient.filter(x1 => x.activeIngredients.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0)) &&
          (gtin.length == 0 || (gtin.filter(x1 => x.gtin.trim().toLowerCase().indexOf(x1.trim().toLowerCase()) > -1).length > 0))
        );
      }

      this.productList.forEach(x => {
        if (this.selectedProductList.filter(y => y.itemNumber.trim() == x.itemNumber.trim() && !x.isParent).length > 0 && this.gridManualProductList.filter(z => z.itemNumber === x.itemNumber).length === 0) {
          x.IsProductSelected = true;
        } else {
          x.IsProductSelected = false;
        }
      });
      this.parentProductList.forEach(x => {
        if (this.selectedProductList.filter(y => y.itemNumber == x.itemNumber && x.isParent).length > 0 && this.gridManualProductList.filter(z => z.itemNumber === x.itemNumber).length === 0) {
          x.IsProductSelected = true;
        } else {
          x.IsProductSelected = false;
        }
      });
      if (this.productList.length === 0 && this.parentProductList.length === 0) {
        this.toastrService.error('No record(s) found for the selected search criteria');
      }
      this.showShipToNonReturnableProducts(this.isShipToNonReturnable);
      this.showParentNonReturnableProducts(this.isParentNonReturnable);

      this.enableDisableAddProductBtn();
      this.loaderService.setLoaderStatus(false);
    }, 500); // 500 milliseconds delay
  }

  // Filter Product GridData based on filter values
  filterProductGridData(filters: any): void {
    this.loaderService.setLoaderStatus(true);
    if (!filters.clearAll) {
      if (this.selectedTabIndex === 2) {
        filters.productLine = filters.productLineIds;
        const sub = this.cppReturnsService.getProductMaster(filters).subscribe({
          next: (result: any) => {
            this.manualProductList = result;
            this.uomMasterList = null;
            this.uomNumber = null;
            this.loaderService.setLoaderStatus(false);
          },
          error: (err) => {
            this.loaderService.setLoaderStatus(false);
          }
        });

        this.subscription.push(sub);
      } else {
        this.getAllProducts(filters);
      }
    } else {
      // When Clear All is clicked
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource(this.productList);

      this.parentProductList = [];
      this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);

      this.manualProductList = null;
      this.resetItems();
      const filter: any = {};
      filters.clearAll = false;
      this.getAllProducts(filter);
    }

    this.enableDisableAddProductBtn();
  }

  // Update selected prodcut list
  keepRecords(product, isProductTab) {
    product.IsProductSelected = !product.IsProductSelected;
    const itemNumber = product.itemNumber;
    const lotNumber = product.lotNumber;
    const isParent = product.isParent;
    if (product.IsProductSelected) {
      this.itemList.push({ 'itemNumber': itemNumber, 'lotNumber': lotNumber });
      let item;
      if (isProductTab) {
        item = this.productList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
      } else {
        item = this.parentProductList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
      }

      this.selectedProductList.push(item[0]);
    }
    else {
      let index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }
    }
    this.enableDisableAddProductBtn();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    if (this.selectedTabIndex === 0) {
      this.setAccInvProdTableHeight();
    } else if (this.selectedTabIndex === 1) {
      this.setcompInvProdTableHeight();
    } else if (this.selectedTabIndex === 2) {
      this.setManualProdTableHeight();
    }
  };

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }
  setManualProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.top-sec').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .manualProdTable').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
    this.setManualProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    //this.setAccInvProdTableHeight();
    //this.setcompInvProdTableHeight();
    //this.setManualProdTableHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  public export() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.productList && this.productList.length > 0) {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'Eligible Units': this.isReturnTypeForInnoculant ? ((x.invoiceUnits) > 0 ? (x.invoiceUnits) : 0) : x.invoiceUnits - x.totalReturnUnits > 0 ? x.invoiceUnits - x.totalReturnUnits : 0,
          'Pack Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'AccountProductsReport');
    } else if (this.selectedTabIndex === 1 && this.parentProductList && this.parentProductList.length > 0) {
      const filteredList = this.parentProductList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'Eligible Units': this.isReturnTypeForInnoculant ? ((x.invoiceUnits) > 0 ? (x.invoiceUnits) : 0) : x.invoiceUnits - x.totalReturnUnits > 0 ? x.invoiceUnits - x.totalReturnUnits : 0,
          'Pack Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'ParentProductsReport');
    }

    this.loaderService.setLoaderStatus(false);
  }

  public isDisableExportButton(): boolean {
    let retVal = true;

    if (this.selectedTabIndex === 0 && this.productList) {
      retVal = this.productList.filter(x => x.displayMessage == null).length === 0;
    } else if (this.selectedTabIndex === 1 && this.parentProductList) {
      retVal = this.parentProductList.filter(x => x.displayMessage == null).length === 0;
    }

    return retVal;
  }

  public isShowExportButton(): boolean {
    return [0, 1].includes(this.selectedTabIndex);
  }
}
